import styled from "styled-components";

export const Header = styled.div`
  font-size: 2em;
  margin:auto;
  text-align: left;
  color: ${({ theme }) => theme.colors.navText};;
  margin-top: 1em;
  margin-bottom: 1em;

  @media screen and (max-width:768px){
    font-size: 1em;
  }
`

export const Label = styled.label`
  color: white;
  display:table-cell;
  font-size: 1.5em;
  margin: 0 auto;
  text-align: right;
  vertical-align:middle;
  @media screen and (max-width:768px){
    font-size: 1em;
  }
`

export const Form = styled.form`
  display: table;
  margin: 0 auto;
`

export const Row = styled.div`
  display: table-row;
`

export const Copyright = styled.div`
  position:fixed;
  bottom:0;
  color:${({ theme }) => theme.colors.navText};
  font-weight:bold;
  width: 100%;
  height: 1em;
  padding-top: 1em;
  padding-bottom: 1em;
  text-align: center;
  background: ${({ theme }) => theme.colors.navBackground};
  filter: drop-shadow(0px 0px .5px black);
  z-index: 100;
  min-width:200px;
`

export const Text = styled.div`
  font-size: 1.5em;
  color: ${({ theme }) => theme.colors.textColor};
  text-align: center;
  padding: 1em;

  @media screen and (max-width:768px){
    font-size: 1.25em;
  }

  @media screen and (max-width:440px){
    font-size: 1.25em;
  }
`

export const AlertText = styled.div`
  font-size: 1.5em;
  color: rgb(255, 0, 0);
  text-align: center;
  margin-top:.5em;
  margin-bottom:1em;
  font-weight: bold;

  @media screen and (max-width:768px){
    font-size: .75em;
  }

  @media screen and (max-width:440px){
    font-size: .5em;
  }
`

export const SeidrPoly = styled.polyline`	
  fill:none;
  stroke:${({ theme }) => theme.colors.secondary};
  stroke-width:41; 
  stroke-miterlimit:10;
  opacity:0;

  &.fast{
    animation: fillFast .5s ease-in .25s forwards;
  
    @keyframes fillFast {
      100% {
        opacity: 100 ;
      }
    }
  }

  &.slow{
    animation: fillSlow .5s ease-in .5s forwards;
  
    @keyframes fillSlow {
      100% {
        opacity: 100 ;
      }
    }
  }
`

export const SeidrContainer = styled.div`
    margin-top:20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`

export const Loading = styled.div`
  position: absolute;
  width: 100vw;
  height:100vh;
  background-color: black;
  z-index:10000;
`

export const Logo = styled.svg`
    position: absolute;
    stroke: ${({ theme }) => theme.colors.secondary};
    left: 10px;

    @media screen and (max-width:768px){
        -ms-transform: scale(.85);
        -webkit-transform: scale(.85); 
        transform: scale(.85);
        position: relative;
        margin-right: 2%;
    }
`

export const ThemeMode = styled.div`
  color:${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  &.dark:before{
      width: 1em;
      height: 1em;
      font-family: "Font Awesome 5 Free"; 
      font-weight: 900; 
      content: "\f186";
      display: inline-block;
      font-size: 1em;

      @media screen and (max-width:440px){
          font-size: .75em;
      }
  }

  &.light:before{
      width: 1em;
      height: 1em;
      font-family: "Font Awesome 5 Free"; 
      font-weight: 900; 
      content: "\f0eb";
      display: inline-block;
      font-size: 1em;

      @media screen and (max-width:440px){
          font-size: .75em;
      }
  }
`

export const Background = styled.div`
  position: absolute;
  width: 100%;
  min-width: 380px;
  height:100vh;
  margin-bottom:10em;
  background-position: center center;
  background-color: ${({ theme }) => theme.colors.background};
  background-repeat: repeat;
  background-attachment: fixed;
  background-image: none;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  padding-bottom:10em;
`

export const ContainerVertical = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width:80%;
  margin:auto;  
  flex-direction: column;
`

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width:80%;
    margin:auto;
    flex-wrap: wrap;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.secondary};

  &.visited{
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const InputBox = styled.input`
  background: none;
  color: ${({ theme }) => theme.colors.textColor};
  font-size: 1.3em;
  width: 15em;
  height: 2em;
  padding-left: .5em;
  margin-right: 1em;
  margin-bottom: 1em;
  border-radius: 2px;

  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};

  ::-webkit-input-placeholder {color: ${({ theme }) => theme.colors.textColor};}  
  :-moz-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  ::-moz-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  :-ms-input-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  ::placeholder {color: ${({ theme }) => theme.colors.textColor};} 

  &:focus::-webkit-input-placeholder { opacity: 0; } 
  &:focus:-moz-placeholder { opacity: 0; } 
  &:focus::-moz-placeholder { opacity: 0; }
  &:focus:-ms-input-placeholder { opacity: 0; }
  &:focus::placeholder { opacity: 0}; 

  &:focus{
    background-color: ${({ theme }) => theme.colors.inputFocus};
  }
  
  @media screen and (max-width:768px){
    width: 10em;
    height: 1.5em;
  }

  @media screen and (max-width:440px){
    width: 8em;
    padding: .5em;
    height: .5em;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover, 
  :-webkit-autofill:focus, 
  :-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.colors.background} inset !important;
  }

  :-webkit-autofill{
    -webkit-text-fill-color: ${({ theme }) => theme.colors.textColor} !important;
  }
`

export const LabelContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:fit-content;
`

export const InputLabel = styled.label`
    color: ${({ theme }) => theme.colors.textColor};
    font-size: 1em;
    white-space: nowrap;
    font-weight: bold;
    
    @media screen and (max-width:440px){ 
      font-size: .75em;
    }
`

export const Alert = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  margin: 0 auto;
  top: 40%;
  left: 50%;
  position:fixed;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 450px;
  background: ${({ theme }) => theme.colors.background};
  border-style: solid;
  border-radius: 7px;
  //border-width: 10pt;
  border-color: ${({ theme }) => theme.colors.secondary};
  filter: drop-shadow(6px 6px 8px black);

  @media screen and (max-width:768px){
    width: 300px;
  }

  @media screen and (max-width:380px){
    width: 200px;
  }
`

export const SubmitButton = styled.button`
  cursor: pointer;
  display: block;
  text-align: center;
  font-size: 1em;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.altButtonText};
  border-radius: 5px;
  border: none;
  width:90px;
  margin: auto;
  margin-top:1em;
  margin-bottom: 1em;
  height:30px;

  background: linear-gradient(to left, ${({ theme }) => theme.colors.altButtonInitial} 50%, ${({ theme }) => theme.colors.altButtonHover} 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.5s ease;

  &:hover{
    background-position: left bottom;
    color:${({ theme }) => theme.colors.altButtonTextHover};
    font-weight: bold;
  }

  @media screen and (max-width:768px){
    -ms-transform: scale(.85);
    -webkit-transform: scale(.85); 
    transform: scale(.85);
    position: relative;
    right: 0;
  }

  @media screen and (max-width:440px){
    -ms-transform: scale(.95);
    -webkit-transform: scale(.95); 
    transform: scale(.95);
  }
`

export const PasswordText = styled.div`
  font-size: 1em;
  color: ${({ theme }) => theme.colors.errorText};
  text-align: left;
  margin-top:.5em;
  font-weight: bold;

  @media screen and (max-width:768px){
    font-size: .75em;
  }

  @media screen and (max-width:380px){
    font-size: .5em;
  }
`

export const LoadingIcon = styled.i`
  font-size: 2.5em;
  color: ${({ theme }) => theme.colors.textColor};

  @-moz-keyframes spin { 
    100% { -moz-transform: rotate(360deg); } 
  }
  @-webkit-keyframes spin { 
      100% { -webkit-transform: rotate(360deg); } 
  }
  @keyframes spin { 
      100% { 
          -webkit-transform: rotate(360deg); 
          transform:rotate(360deg); 
      } 
  }

  -webkit-animation:spin 4s linear infinite;
  -moz-animation:spin 4s linear infinite;
  animation:spin 4s linear infinite;
`

export const BackButton = styled.div`
  color:${({ theme }) => theme.colors.secondary};
  position: absolute;
  cursor: pointer;
  left:2%;
  z-index:100;
  &:before{
    width: 1em;
    height: 1em;
    font-family: "Font Awesome 5 Free"; 
    font-weight: 900; 
    content: "\f060";
    display: inline-block;
    font-size: 2.5em;

    @media screen and (max-width:786px){
      font-size: 2em;
    }

    @media screen and (max-width:380px){
      font-size: 1.5em;
    }
  }
`

export const TabList = styled.ol`
  display:flex;
  overflow-x: auto;
  width: 80%;
  padding: 0;
  margin:auto;

  ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.trackColor};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.thumbColor};
  }

  ::-webkit-scrollbar-corner{
    background-color: ${({ theme }) => theme.colors.trackColor};
  }
`

export const TabListItem = styled.li`
  font-size: 1em;
  list-style: none;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  white-space:nowrap;
  color: ${({ theme }) => theme.colors.textColor};
  opacity: .5;

  &.active{
    opacity: 1;
    border: solid ${({ theme }) => theme.colors.tabBorder};
    border-width: 0px 0px .25em 0px;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: bold;
  }

  &.high{
    color: ${({ theme }) => theme.colors.high};
    font-weight:bold;
  }

  &.urgent{
    color: ${({ theme }) => theme.colors.urgent};
    font-weight:bold;
  }

  @media screen and (max-width:768px){
    font-size: .75em;
  }

  @media screen and (max-width:380px){
    font-size: .5em;
  }
`

export const PageBreak = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.pageBreak};
  width: 80%;
  margin:auto;
  margin-top: 1%;
  margin-bottom: 1%;

  &.noMarginTop{
    margin-top:0px;
  }

  @media screen and (max-width:768px){
    margin-top: 2%;
    margin-bottom: 2%;
  }

  @media screen and (max-width:380px){
    margin-top: 4%;
    margin-bottom: 4%;
  }
`
